import React from 'react';
import { Box } from 'grommet';
import { colors } from '@theme/globals/colors';

interface OutTrackerProps {
  outs?: number;
}

const OutTracker: React.FC<OutTrackerProps> = ({ outs = 0 }) => {
  return (
    <Box
      className="outs"
      direction="row"
      justify="center"
      margin={{ bottom: 'xxsmall' }}
    >
      <Outmarker out={outs > 0 && outs <= 3} base="1st" />
      <Outmarker out={outs > 1 && outs <= 3} base="2nd" />
      <Outmarker out={outs === 3} base="3rd" />
    </Box>
  );
};

const Outmarker: React.FC<{ out: boolean; base: string }> = ({ out, base }) => {
  return (
    <Box
      data-testid={`${base}-base`}
      data-outs={out}
      margin={{ horizontal: '0.075rem' }}
      round="full"
      height="8px"
      width="8px"
      background={
        out
          ? (colors['black-alpha-80'] as string)
          : (colors['black-alpha-20'] as string)
      }
    ></Box>
  );
};

export default OutTracker;
